<template>
    <div :class="classes">
        {{ counter }}
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        counter: {
            type: Number,
            required: true,
        },
        info: {
            type: Boolean,
            default: false
        },
        success: {
            type: Boolean,
            default: false,
        },
        warning: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        accent: {
            type: Boolean,
            default: false,
        },
        highlight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes: function (){
            let classList = [
                'kgr-badge',
            ];

            if (this.info) {
                classList.push('kgr-badge--info')
            }
            if (this.success) {
                classList.push('kgr-badge--success')
            }
            if (this.warning) {
                classList.push('kgr-badge--warning')
            }
            if (this.error) {
                classList.push('kgr-badge--error')
            }
            if (this.accent) {
                classList.push('kgr-badge--accent')
            }
            if (this.highlight) {
                classList.push('kgr-badge--highlight')
            }

            return classList.join(' ');
        }
    }
}
</script>
